import React, { FC, useState } from 'react'
import { Container } from './SearchBox.styles'
import SearchButton from './SearchButton'
import TextField from './TextField'
import Toggle from './Toggle'
import Selection from './Selection'
import { IdType } from '../types'

interface SearchBoxProps {
  isSearching: boolean
  handleSearch: (input: string, idType: IdType) => void
  refresh: boolean
  setRefresh: (input: boolean) => void
}

const SearchBox: FC<SearchBoxProps> = ({
  isSearching,
  handleSearch,
  refresh,
  setRefresh,
}) => {
  const [searchText, setSearchText] = useState('')
  const [selectedIdType, setSelectedIdType] = useState<IdType>('vehicleId')
  const buttonContent = isSearching ? <div className="spinner" /> : 'Zoeken'
  return (
    <Container>
      <TextField
        value={searchText}
        onChange={(e) => setSearchText(e.currentTarget.value)}
        placeholder={selectedIdType}
        onEnter={() => handleSearch(searchText, selectedIdType)}
      />
      <Selection
        value={selectedIdType}
        onChange={(e) => setSelectedIdType(e.target.value as IdType)}
      >
        <option value="vehicleId">Vehicle</option>
        <option value="blockId">Block</option>
        <option value="tripId">Trip</option>
      </Selection>
      <SearchButton onClick={() => handleSearch(searchText, selectedIdType)}>
        {buttonContent}
      </SearchButton>
      <Toggle checked={refresh} setChecked={setRefresh} />
    </Container>
  )
}
export default SearchBox
